import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import useListService from '@/data/hook/useListService';
import { enrollmentsQueryKeys } from '@/data/services/querykeys';
import { EnrollmentStatusEnum } from '@/models/Enrollment';

const ENROLLMENT_STATUSES = [
  EnrollmentStatusEnum.ACTIVE,
  EnrollmentStatusEnum.CONCLUDED,
  EnrollmentStatusEnum.CANCELED,
];

type UseStudentEnrollmentsProps = {
  studentId?: number;
};

export default function useStudentEnrollments({
  studentId,
}: UseStudentEnrollmentsProps) {
  const { results: enrollments, isInitialLoading } = useListService({
    ...enrollmentsQueryKeys.byStudent(studentId ?? 0, {
      status: ENROLLMENT_STATUSES,
    }),
    enabled: !!studentId,
    staleTime: REQUEST_STALE_TIME_IN_MS,
  });

  return { enrollments, isLoading: isInitialLoading };
}
